import classNames from 'classnames';
import { forwardRef, memo, useState } from 'react';

import { getUserDisplayName, getUserInitials } from 'my-core/user-utils';

import Avatar from '@mui/material/Avatar';

import { faUser, faUserSecret } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const userIdMapping = {};
let colorIdx = 0;
const COLORS = ['primary', 'secondary', 'green', 'purple', 'cyan', 'orange'];
export default memo(
  forwardRef(function MuiAvatar(props, ref) {
    const {
      alt,
      anonymous,
      avatar: avatarProp,
      className,
      color: colorProp,
      showInitials,
      size = 120,
      src = 'normal',
      user,
      ...rest
    } = props;
    const avatar = avatarProp || user?.avatar;
    const label = alt || `${getUserDisplayName(user) || 'student'} avatar`;
    const [color] = useState(() => {
      if (colorProp) return colorProp;
      if (userIdMapping[user?.id]) return userIdMapping[user.id];
      const color = COLORS[(colorIdx = (colorIdx + 1) % COLORS.length)];
      if (user?.id) userIdMapping[user.id] = color;
      return color;
    });

    if (anonymous || !avatar || avatar.is_silhouette || !avatar[src]) {
      const initials = !anonymous && showInitials && getUserInitials(user);
      return (
        <Avatar
          {...rest}
          aria-label={anonymous ? undefined : label}
          className={classNames(color, className)}
          css={[rootCss, { width: size, height: size }]}
          ref={ref}
          role={anonymous ? undefined : 'img'}
        >
          {initials || (
            <FontAwesomeIcon
              className={classNames('MA-icon', { 'MA-anonymous': anonymous })}
              icon={anonymous ? faUserSecret : faUser}
            />
          )}
        </Avatar>
      );
    }
    return (
      <Avatar
        {...rest}
        alt={label}
        className={className}
        css={[rootCss, { width: size, height: size }]}
        ref={ref}
        src={avatar.is_processing ? avatar.original : avatar[src]}
      />
    );
  }),
);

const rootCss = ({ palette }) => ({
  color: palette.common.white,
  backgroundColor: palette.common.white,
  '.MA-icon': {
    width: '40% !important',
    height: '40% !important',
  },
  '.MA-icon.MA-anonymous': {
    width: '60% !important',
    height: '60% !important',
  },

  '&.primary': { backgroundColor: palette.primary.main },
  '&.secondary': { backgroundColor: palette.secondary.main },
  '&.green': { backgroundColor: palette.green.main },
  '&.purple': { backgroundColor: palette.purple.main },
  '&.cyan': { backgroundColor: palette.cyan.main },
  '&.orange': { backgroundColor: palette.orange.main },
});
